// FieldLabel — small form field label.
// Mirrors `.field-label` in /Users/harry/Downloads/employee-portal/project/styles.css
// (lines 820–828). Used above inputs inside drawers, freq-expanded forms, the
// profile sheet, etc.
//
// Spec: 12px / 500 / neutral.800, margin-bottom 6px (`1xs`). When `onClear` is
// supplied, a "Clear" link sits on the right (`.clear-link`: 12px / 500 /
// p.600 → hover p.700). The container is a flex row with space-between so the
// link aligns to the right edge of the field.

import { Box, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

export interface FieldLabelProps {
  children: ReactNode;
  /** When provided, shows a "Clear" link on the right that calls this handler. */
  onClear?: () => void;
  /** Override the link label. Default "Clear". */
  clearLabel?: string;
}

const FieldLabel = ({ children, onClear, clearLabel = "Clear" }: FieldLabelProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      fontSize="xs"
      fontWeight={500}
      color="neutral.800"
      mb="1xs"
    >
      <Box as="span">{children}</Box>
      {onClear && (
        <Text
          as="button"
          type="button"
          onClick={onClear}
          fontSize="xs"
          fontWeight={500}
          color="p.600"
          cursor="pointer"
          background="transparent"
          border="none"
          padding={0}
          _hover={{ color: "p.700" }}
        >
          {clearLabel}
        </Text>
      )}
    </Box>
  );
};

FieldLabel.displayName = "FieldLabel";

export default FieldLabel;
